import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movement_create_component = _resolveComponent("movement-create-component")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    persistent: "",
    "no-shake": "",
    "full-width": !_ctx.isMobile,
    maximized: _ctx.isMobile,
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_movement_create_component, {
        "existing-movement-id": _ctx.existingMovementId,
        "create-type": _ctx.createType,
        onClose: _ctx.handleClose
      }, null, 8, ["existing-movement-id", "create-type", "onClose"])
    ]),
    _: 1
  }, 8, ["full-width", "maximized", "onHide"]))
}